export default __webpack_public_path__ + "static/media/720.961ba18c.gif";